import { Reveal, Overline } from "./Reveal";
import { MEDIA } from "../data/content";

export const History = ({ t }) => (
  <section id="history" data-testid="history-section" className="py-24 md:py-36 bg-copou-bg">
    <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
      <Reveal className="relative">
        <div className="relative overflow-hidden">
          <img src={MEDIA.history} alt="Raze de soare printre copacii din Copou" className="w-full h-[420px] md:h-[560px] object-cover" />
        </div>
        <div className="absolute -bottom-6 -right-4 md:right-8 bg-copou-primary text-white px-8 py-6">
          <div className="font-serif text-4xl md:text-5xl leading-none">1834</div>
          <div className="text-[11px] uppercase tracking-[0.2em] mt-2 text-white/80">Grădina Copou</div>
        </div>
      </Reveal>

      <Reveal delay={0.1}>
        <Overline>{t.history.overline}</Overline>
        <h2 className="font-serif font-light text-4xl sm:text-5xl tracking-tight mt-4 text-copou-ink">{t.history.title}</h2>
        <p className="mt-7 text-copou-muted leading-relaxed text-base md:text-lg">{t.history.p1}</p>
        <p className="mt-5 text-copou-muted leading-relaxed text-base md:text-lg">{t.history.p2}</p>
        <div className="mt-8 flex gap-10 border-t border-copou-line pt-8">
          <div>
            <div className="font-serif text-3xl text-copou-primary">1689</div>
            <div className="text-xs uppercase tracking-wider text-copou-muted mt-1">Prima atestare</div>
          </div>
          <div>
            <div className="font-serif text-3xl text-copou-primary">1860</div>
            <div className="text-xs uppercase tracking-wider text-copou-muted mt-1">Universitatea</div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
